// features/spark/scripts/static-generate.ts 로 생성된 파일입니다.
// next.js 에서 이 파일을 복사해서 사용하면 됩니다.
import rewarddesktop960 from '@flipster/features/static/spark/reward/reward_desktop_960_1x.webp';
import rewarddesktop1920 from '@flipster/features/static/spark/reward/reward_desktop_960_2x.webp';
import reward from '@flipster/features/static/spark/reward/reward_mobile_360_1x.webp';
import rewardmobile360 from '@flipster/features/static/spark/reward/reward_mobile_360_1x.webp';
import rewardmobile720 from '@flipster/features/static/spark/reward/reward_mobile_360_2x.webp';
import rewardmobile420 from '@flipster/features/static/spark/reward/reward_mobile_420_1x.webp';
import rewardmobile840 from '@flipster/features/static/spark/reward/reward_mobile_420_2x.webp';
import rewardmobile768 from '@flipster/features/static/spark/reward/reward_mobile_768_1x.webp';
import rewardmobile1536 from '@flipster/features/static/spark/reward/reward_mobile_768_2x.webp';

export default {
  img: {
    src: reward.src,
    width: 360,
    height: 483,
    alt: 'What’s the reward?',
  },
  sources: [
    {
      media: '(max-width: 767px)',
      srcSet: [
        `${rewardmobile360.src} 360w`,
        `${rewardmobile720.src} 720w`,
        `${rewardmobile420.src} 420w`,
        `${rewardmobile840.src} 840w`,
        `${rewardmobile768.src} 768w`,
        `${rewardmobile1536.src} 1536w`,
      ].join(', '),
      sizes: '100vw',
    },
    {
      srcSet: [`${rewarddesktop960.src} 960w`, `${rewarddesktop1920.src} 1920w`].join(', '),
      sizes: '960px',
    },
  ],
};
